import React from 'react';
import ProductTopSection from '../../../components/Sangjo-Ujieon/ProductTopSection';
import ProductSubHeading from '../../../components/Sangjo-Ujieon/ProductSubHeading';
import openingMovingIcon1 from '../../../assets/img/product-info/open1.png';
import openingMovingIcon2 from '../../../assets/img/product-info/open2.png';
import openingMovingIcon3 from '../../../assets/img/product-info/open3.png';
import openingMovingIcon4 from '../../../assets/img/product-info/open4.png';
import openingMovingIcon5 from '../../../assets/img/product-info/open5.png';
import { IoIosArrowForward } from "react-icons/io";


const OpeningMovingPC = () => {

  return (
    <div className="announcement-list-page product-info-page">
      <ProductTopSection />

      {/* Main Content */}
      <main className="main-content">
        <ProductSubHeading heading="개장/이장" />

        <div className="opening-moving-page-content">

          {/* Procedure Steps Section */}
          <section className="opening-moving-content-section">
            <h3 className="opening-moving-section-title">개장/이장 절차</h3>
            <div className="opening-moving-steps-container">
              <div className="opening-moving-step-item">
                <p>이장지 결정</p>
                <div className="opening-moving-step-icon-wrapper">
                  <img src={openingMovingIcon1} className="opening-moving-icon" alt="이장지 결정 아이콘" />
                </div>
              </div>
              <div className="opening-moving-step-arrow">
                <div className="opening-moving-arrow-icon">
                  <IoIosArrowForward />
                </div>
              </div>
              <div className="opening-moving-step-item">
                <p>개장 신고</p>
                <div className="opening-moving-step-icon-wrapper">
                  <img src={openingMovingIcon3} className="opening-moving-icon" alt="개장 신고 아이콘" />
                </div>
              </div>
              <div className="opening-moving-step-arrow">
                <div className="opening-moving-arrow-icon">
                  <IoIosArrowForward />
                </div>
              </div>
              <div className="opening-moving-step-item">
                <p>파묘</p>
                <div className="opening-moving-step-icon-wrapper">
                  <img src={openingMovingIcon2} className="opening-moving-icon" alt="파묘 아이콘" />
                </div>
              </div>
              <div className="opening-moving-step-arrow">
                <div className="opening-moving-arrow-icon">
                  <IoIosArrowForward />
                </div>
              </div>
              <div className="opening-moving-step-item">
                <p>화장 및 운구</p>
                <div className="opening-moving-step-icon-wrapper">
                  <img src={openingMovingIcon4} className="opening-moving-icon" alt="화장 및 운구 아이콘" />
                </div>
              </div>
              <div className="opening-moving-step-arrow">
                <div className="opening-moving-arrow-icon">
                  <IoIosArrowForward />
                </div>
              </div>
              <div className="opening-moving-step-item">
                <p>안치</p>
                <div className="opening-moving-step-icon-wrapper">
                  <img src={openingMovingIcon5} className="opening-moving-icon" alt="안치 아이콘" />
                </div>
              </div>
            </div>
          </section>

          {/* Report Process Section */}
          <section className="opening-moving-content-section">
            <h3 className="opening-moving-section-title">개장신고</h3>
            <div className="opening-moving-process-container">
              <div className="opening-moving-process-item">
                <div className="opening-moving-process-number"><span>1</span></div>
                <h4>신고</h4>
                <p>개장신고서 작성</p>
              </div>
              <div className="opening-moving-process-item">
                <div className="opening-moving-process-number"><span>2</span></div>
                <h4>접수</h4>
                <p>개장신고자와 사망자의<br />관계 확인 (제적등본)</p>
              </div>
              <div className="opening-moving-process-item">
                <div className="opening-moving-process-number"><span>3</span></div>
                <h4>확인</h4>
                <p>개장신고사항 확인</p>
              </div>
              <div className="opening-moving-process-item">
                <div className="opening-moving-process-number"><span>4</span></div>
                <h4>검토</h4>
                <p>개장신고사항<br />적합여부 검토</p>
              </div>
              <div className="opening-moving-process-item">
                <div className="opening-moving-process-number"><span>5</span></div>
                <h4>결재</h4>
                <p>결재</p>
              </div>
              <div className="opening-moving-process-item">
                <div className="opening-moving-process-number"><span>6</span></div>
                <h4>작성</h4>
                <p>관리대장 등 작성</p>
              </div>
              <div className="opening-moving-process-item">
                <div className="opening-moving-process-number"><span>7</span></div>
                <h4>수리</h4>
                <p>개장신고 증명서<br />발급 교부</p>
              </div>
            </div>
            <ul className="opening-moving-info-list">
              <li>신고유형 : 사전신고제</li>
              <li>신고의무자 : 개장을 하려는 자</li>
              <li>신고기관 : 시체, 유골의 현존지. 개장지를 관할하는 주민자치센터</li>
              <li>구비서류 : 기존분묘의 사진 (분묘에 비석이 포함된 근거리, 원거리 사진)</li>
            </ul>
          </section>

          {/* Priority Order Section */}
          <section className="opening-moving-content-section">
            <h3 className="opening-moving-section-title">개장신고 우선순위</h3>
            <div className="opening-moving-priority-container">
              <div className="opening-moving-priority-item">
                <div className="opening-moving-priority-number">1순위</div>
                <p>배우자</p>
              </div>
              <div className="opening-moving-priority-item">
                <div className="opening-moving-priority-number">2순위</div>
                <p>자식</p>
              </div>
              <div className="opening-moving-priority-item">
                <div className="opening-moving-priority-number">3순위</div>
                <p>부모</p>
              </div>
              <div className="opening-moving-priority-item">
                <div className="opening-moving-priority-number">4순위</div>
                <p>부모를 제외한 직계존속</p>
              </div>
              <div className="opening-moving-priority-item">
                <div className="opening-moving-priority-number">5순위</div>
                <p>형제/자매</p>
              </div>
            </div>
            <p className="opening-moving-priority-note">동순위의 자녀 또는 직계비속이 2인 이상일 때는 최친근의 연장자를 우선순위로 한다.</p>
          </section>

          {/* Required Documents Section */}
          <section className="opening-moving-content-section">
            <h3 className="opening-moving-section-title">개장/이장 시 필요 서류</h3>
            <div className="opening-moving-docs-subsection">
              <h4>분묘개장신고필증 발급신청 시 필요 서류</h4>
              <ul className="opening-moving-list-style-bullet">
                <li>분묘이장 신청자(직계가족)의 도장, 주민등록증 지참</li>
                <li>분묘의 정확한 주소와 지번을 알고 계셔야 좋습니다.</li>
                <li>망자의 가족관계 증명서 - 호적등본(제적등본) 1통</li>
                <li>분묘 현장사진 1장(비석이 있을 경우 쓰여진 글자가 보일 수 있게 찍습니다.)</li>
              </ul>
            </div>
            <div className="opening-moving-docs-subsection">
              <h4>분묘개장신고필증 발급신청 시 필요 서류</h4>
              <ul className="opening-moving-list-style-bullet">
                <li>대리신고시 – 직계 권리자의 위임장 1장, 위임용 인감 1부, 주민등록등본 1부, 가족관계증명서 1부</li>
                <li>배정을 한자는 매장 후 30일 이내 관할 읍, 면사무소에 신고해야합니다. (법 제 8조 1항)</li>
                <li>매장신고시 묘지설치신고를 함께하면 이중으로 관청에 출입하는 분평이 없습니다.</li>
              </ul>
            </div>
            <div className="opening-moving-docs-subsection">
              <h4>화장장 예약시 필요 서류</h4>
              <ul className="opening-moving-list-style-bullet">
                <li>화장장 이용서류</li>
                <li>연고자 주민등록 등/초본</li>
                <li>묘지 개장 신고필증 1부</li>
              </ul>
            </div>
          </section>
        </div>
      </main>

    </div>
  );
};

export default OpeningMovingPC; 